import React from 'react';
import ToggleRow from '@/components/table/ToggleRow';
import hasPermission from '../helper';
import { roleGroupings } from '../constants';

const PermissionRow = ({
  category,
  action,
  grouping = roleGroupings.USERS,
  onClick,
  disabled,
  permissions,
}) => (
  <ToggleRow
    context="permission"
    icons={[category.icon, action.icon]}
    message={`permissions.${grouping}.${category.name}.${action.name}.title`}
    checked={hasPermission(permissions, category.name, action.name)}
    disabled={disabled}
    onClick={onClick}
    label={action.name}
  />
);

export default PermissionRow;
